import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const LOCALE_PREFIXES = {
  pl: "/pl",
  de: "/de",
  en: "/en",
  es: "/es",
  fr: "/fr",
  it: "/it",
};

const SITE_URL = "https://revealoo.com";

const SeoHelmet = ({
  title,
  description,
  image = "/og_image.png",
  url,
  children,
}) => {
  const { i18n } = useTranslation();

  const lang = LOCALE_PREFIXES[i18n.language] ? i18n.language : "en";
  const prefix = LOCALE_PREFIXES[lang];

  // Obliczanie pathname (dla server-side będzie "/" więc SEO się nie sypie)
  let pathname = "/";
  if (typeof window !== "undefined") {
    pathname = window.location.pathname.replace(/^\/(pl|de|en|es|fr|it)(\/|$)/, "/");
  }

  const currentUrl =
    url || `${SITE_URL}${prefix}${pathname !== "/" ? pathname : ""}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={currentUrl} />
      {/* OpenGraph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={currentUrl} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {/* Alternatywy językowe (SEO) */}
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/en${pathname}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}/en${pathname}`} />
      <link rel="alternate" hrefLang="pl" href={`${SITE_URL}/pl${pathname}`} />
      <link rel="alternate" hrefLang="de" href={`${SITE_URL}/de${pathname}`} />
      <link rel="alternate" hrefLang="es" href={`${SITE_URL}/es${pathname}`} />
      <link rel="alternate" hrefLang="fr" href={`${SITE_URL}/fr${pathname}`} />
      <link rel="alternate" hrefLang="it" href={`${SITE_URL}/it${pathname}`} />
      {children}
    </Helmet>
  );
};

export default SeoHelmet;
